import { z } from 'zod/v4';

/**
 * One archive row to remove. Archiving is per company —
 * `company_documents_archived` is keyed `(document_id, company_id)` — so a
 * restore names the company whose archive row goes; a bare document id would
 * un-archive the document for every company that had archived it.
 */
export const AdminCompanyDocumentRestoreItemSchema = z
  .object({
    documentId: z.string().min(1),
    companyId: z.string().min(1),
  })
  .strict();

export type AdminCompanyDocumentRestoreItem = z.infer<
  typeof AdminCompanyDocumentRestoreItemSchema
>;

export const AdminBulkRestoreCompanyDocumentsBodySchema = z
  .array(AdminCompanyDocumentRestoreItemSchema)
  .min(1);

export type AdminBulkRestoreCompanyDocumentsBody = z.infer<
  typeof AdminBulkRestoreCompanyDocumentsBodySchema
>;

/**
 * The pairs this call took out of the archive. A pair with no archive row is
 * skipped rather than failing the batch, so this can be shorter than the
 * request. Legacy answered an empty 200.
 */
export const AdminBulkRestoreCompanyDocumentsResponseSchema = z.object({
  restored: z.array(
    z.object({ documentId: z.string(), companyId: z.string() }),
  ),
});

export type AdminBulkRestoreCompanyDocumentsResponse = z.infer<
  typeof AdminBulkRestoreCompanyDocumentsResponseSchema
>;
